import {
  ADMIN_VALUE,
  clientArray,
  scotpacArray,
  STAFF_VALUE,
  INVITED_VALUE,
  COMPANY_VALUE,
} from "utils/constants";

/**
 *
 * @param role
 * @param roles
 * @returns {boolean}
 * @desc returns true when the roles includes the role
 */
const trueRoles = (role: string, roles = [INVITED_VALUE, ADMIN_VALUE]) =>
  roles.includes(role);

// @ts-expect-error
const isStaff = (role: string | undefined) => scotpacArray.includes(role);

const isStaffUser = (role: string | undefined) => role === STAFF_VALUE;

const isClient = (role: string) => clientArray.includes(role);

const isPartnerPortalRole = (role: string | undefined) => {
  if (!role) throw new Error(`Invalid role: ${role}`);
  return [
    ...scotpacArray,
    ...clientArray,
    COMPANY_VALUE,
    STAFF_VALUE,
    ADMIN_VALUE,
    INVITED_VALUE,
  ].includes(role);
};

const resolveEffectiveRole = (roles: string[] = []): string | undefined =>
  roles.find((role) => role !== INVITED_VALUE && isPartnerPortalRole(role)) ??
  roles.find((role) => role === INVITED_VALUE);

export {
  trueRoles,
  isStaff,
  isClient,
  isStaffUser,
  isPartnerPortalRole,
  resolveEffectiveRole,
};
